import React from 'react';

const QuickListContext = React.createContext({});
 
export {QuickListContext};